import React from 'react';
import './App.css';

function GenerateButton({ onClick, isLoading, disabled }) {
  return (
    <button 
      className="generate-button"
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? 'Gerando...' : 'Gerar Startup'}
    </button>
  );
}

export default GenerateButton;
